import React, { FC, useEffect, useState } from 'react';
import { RouterView } from './views/general/RouterView';
import styled, { ThemeProvider } from 'styled-components';
import { AlertPopup, Colors, CommonStyleProvider, THEME } from '@dew21/ui';
import { HashRouter } from 'react-router-dom';
import { CommonStoreHandlerProvider } from '../store/CommonStoreHandler';
import { isChromeBrowser } from '../utils/isChromeBrowser';
import { ApiDispatchHandler } from './ApiDispatchHandler';

const AdministrationWrapper = styled.div`
  background-color: ${Colors.background};
`;

export const App: FC = () => {
  const [isChrome, setIsChrome] = useState<boolean>(false);
  useEffect(() => {
    setIsChrome(isChromeBrowser());
  }, []);
  return (
    <ThemeProvider theme={THEME.default}>
      <CommonStyleProvider/>
      <CommonStoreHandlerProvider>
        {
          isChrome ? (
            <ApiDispatchHandler>
              <AdministrationWrapper>
                <HashRouter>
                  <RouterView/>
                </HashRouter>
              </AdministrationWrapper>
            </ApiDispatchHandler>
          ) : (
            <AlertPopup open hideCloseIcon renderContent={() => (
              <>Die Administration des digitalen Produktkatalogs steht nur im Google Chrome zur Verfügung!</>
            )}/>
          )
        }
      </CommonStoreHandlerProvider>
    </ThemeProvider>
  );
};

export default App;
